// Import
import React, { useState, useEffect } from "react"
import "react-responsive-carousel/lib/styles/carousel.min.css"
import "react-indiana-drag-scroll/dist/style.css"
import { useSectionServiceData } from "@queries"
import { Select } from "@molecules"
import { Section } from "@layout"
import { ServicesFilter } from "./services-filter"
import { ServicesCard } from "./services-card"

export const Services = () => {
  // Get data from query
  const { title, filters, serviceCards } = useSectionServiceData()

  const [displayData, setDisplayData] = useState(
    serviceCards.filter((service) => !service.small)
  )
  const [displayDataAll, setDisplayDataAll] = useState(serviceCards)
  const [active, setActive] = useState("Összes")
  const [smallServiceCards, setSmallServiceCards] = useState([])

  const handleCategoryClick = (category) => {
    if (category === active) return
    setActive(category)

    if (category === "Összes") {
      setDisplayData(serviceCards.filter((service) => !service.small))
      setDisplayDataAll(serviceCards)
      return
    }

    const filteredData = serviceCards.filter(
      (item) => item.filters !== null && item.filters.includes(category)
    )
    setDisplayDataAll(filteredData)
    setDisplayData(filteredData)
  }

  useEffect(() => {
    let smallCards = serviceCards.filter((service) => service.small)
    setSmallServiceCards(smallCards)
  }, [serviceCards])

  return (
    <Section name="services">
      <div className="services-container">
        <h1> {title} </h1>
        <div className="services-filter__mobile">
          <Select options={filters} onChange={handleCategoryClick} />
        </div>
      </div>
      <ServicesFilter
        filters={filters}
        active={active}
        handleCategoryClick={handleCategoryClick}
      />
      <ServicesCard
        active={active}
        displayData={displayData}
        displayDataAll={displayDataAll}
        smallServiceCards={smallServiceCards}
      />
    </Section>
  )
}
